// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"17d80f72","453":"04a6d75e"}[chunkId] + ".chunk.js";
};